import type { RouteObject } from 'react-router-dom';

import PasswordReset from 'pages/password-reset';
import Sublogin from 'pages/sublogin';

import Login from '../pages/login';
import Register from '../pages/register';
import CheckEmailPage from '../pages/check-email';
import ForgotPassword from '../pages/forgot-password';

export const authRoutes: RouteObject[] = [
  {
    path: 'register',
    element: <Register />,
  },
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: 'check-email',
    element: <CheckEmailPage />,
  },
  {
    path: 'resetPassword',
    element: <PasswordReset />,
  },
  {
    path: 'sublogin',
    element: <Sublogin />,
  },
];
